module.exports = __webpack_public_path__ + "img/marker-point-rosa.8375e674.png";